// Spec: <div data-lr-embed-product="zz-plant" data-cta="Buy Now" data-b2b></div>
class EmbeddedProduct {
  el: HTMLElement;

  productHandle?: string;

  ctaLabel: string;

  isB2B: boolean;

  constructor(el: HTMLElement) {
    this.el = el;
    this.productHandle = this.el.dataset.lrEmbedProduct;
    this.ctaLabel = this.el.dataset.cta || 'View Product';
    this.isB2B = this.el.dataset.b2b !== undefined;

    if (this.productHandle) {
      this.fetchAndRender();
    }
  }

  async fetchAndRender() {
    try {
      const url = `${this.isB2B ? 'https://b2b.livelyroot.com' : ''}/products/${this.productHandle}?view=embedded`;
      const res = await fetch(url);
      if (!res.ok) {
        return;
      }
      const html = await res.text();

      this.el.innerHTML = html;
      this.el.classList.add('embedded-product-wrapper');
      const ctaBtn = this.el.querySelector('.js-embedded-product-cta');

      if (ctaBtn) {
        ctaBtn.innerHTML = this.ctaLabel;
      }
    } catch (err) {
      console.error(`Error embedding product with handle ${this.productHandle}`);
    }
  }
}

export default EmbeddedProduct;
